import { BasicButton } from "@goodgamestudios/asset-globals";

import {
    BasicCustomCursor,
    BasicModel,
    CountrySelectComponent,
    EnvGlobalsHandler,
    GGSCountryController,
    IEnvironmentGlobals
} from "@goodgamestudios/core";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class Poker2ChoiceLanguageComponent extends CountrySelectComponent {
    private _isPositionUpdated: boolean;

    constructor(languageMC: MovieClip) {
        super(languageMC, null, GGSCountryController.instance.activeCountries, 2, BasicModel.languageData.getTextById);
        this._countryMC.mc_currentflag.mouseEnabled = false;
        this._countryMC.mc_currentflag.mouseChildren = false;
        this._countryMC.btn_arrow.mouseEnabled = false;
        // need to remove listener first since we reuse the assets
        this._countryMC.btn_toggle.removeAllEventListeners(MouseEvent.CLICK);
        this._countryMC.btn_toggle.addEventListener(MouseEvent.CLICK, this.bindFunction(this.toggleCountryPopUp));
        this._countryMC.uncache();
    }

    public destroy(): void {
        super.destroy();
        this._countryMC.btn_toggle.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.toggleCountryPopUp));
    }

    protected selectChild(child: MovieClip): void {
        super.selectChild(child);
        if (child instanceof BasicButton) {
            child.selected();
        }
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    }

    // Called from toggleCountryPopUp handler in core...
    public showChoiceCountry(): void {
        this._bgOffsetHeight = -10; // so it looks 100% the same as in Flash ;P
        this._countryMC.mc_bg.y -= 5;

        this._isPositionUpdated = true;

        super.showChoiceCountry();
    }

    public hideChoiceCountry(): void {
        if(this._isPositionUpdated) {
            this._bgOffsetHeight = 0; // restore the values
            this._countryMC.mc_bg.y += 5;
        }

        super.hideChoiceCountry();
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    /**
     * Override original to avoid `findDefinitionByName` error, we don't have corresponding assets for poker, will use
     * tooltip
     * @param event mouseevent
     */
    public showCountryNameTooltip(event) {
        let countryBtn = event.currentTarget;
        Poker2LayoutManager.getInstance().tooltipManager.show(Poker2Model.languageData.getTextById("generic_language_" + countryBtn.country.ggsLanguageCode), countryBtn);
    }

    public hideCountryNameTooltip(event) {
        Poker2LayoutManager.getInstance().tooltipManager.hide();
    }

}

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import { Poker2LayoutManager } from "./Poker2LayoutManager";
import { Poker2Model } from "../model/Poker2Model";
